export enum GetPathes {
  GET_CONFIG = '/config',
  GET_ADYEN_STORES = '/adyenStores',
  GET_BRANCHES = '/cashassist/branches',
  GET_CAPTIONS = '/cashassist/captions',
  GET_USERS = '/notifications/userList',
  CHECK_PAYMENT = '/payment_health',
  GET_CACHE_STATUS = '/cache_status'
}

export enum PostPathes {
  UPD_ADDRESS = '/cashassist/update_address',
  UPD_INTERFACE = '/upsert_interface',
  UPD_LANGUAGE = '/update_languages_config',
  UPD_CC_INTERFACE = '/upsert_click_collect_config',
  UPD_CONFIG = '/upsert_menu_config',
  UPD_PAYMENT = '/upsert_payment_config',
  UPD_TABLE_RES = '/upsert_table_reservation_config',
  SEND_NOTIFICATIONS = '/notifications/send',
  ENCODE_URL_PARAMS = '/encode_url_params',
  UPSERT_CACHE_CONFIG = '/upsert_cache_config'
}

export type UpdateInterfacePayloadType = {
  appIcon: any
  logoImage: any
  backgroundImage: any
  appTheme: 'light' | 'dark'
  colour: string
  font: string
  productViewType: 'list' | 'tile'
  waiterCall: boolean
  agbText: string
  dsvgoText: string
}
